import Intersect from 'vuetify/lib/directives/intersect';
import Ripple from 'vuetify/lib/directives/ripple';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      !_setup.laboratoryList.length
        ? _c(_setup.NothingFound, {
            attrs: { "data-qa": "laboratories-list-content-not-found" },
          })
        : _c(
            "div",
            { attrs: { "data-qa": "laboratories-list-content-labs" } },
            [
              _vm._l(_setup.laboratoryList, function (item, index) {
                return _c(
                  "div",
                  {
                    directives: [{ def: Ripple, name: "ripple", rawName: "v-ripple" }],
                    key: `${index}-${item.id}`,
                    staticClass:
                      "py-3 cursor-pointer d-flex align-center justify-space-between",
                    class: _vm.xSpaceClass,
                    attrs: {
                      "data-qa": `laboratories-list-content-lab-item-${item.lpu.id}`,
                    },
                    on: {
                      click: function ($event) {
                        return _setup.handleClickLab(item)
                      },
                    },
                  },
                  [
                    _c("div", [
                      _c(
                        "div",
                        {
                          staticClass: "text-body-1 text--text",
                          attrs: {
                            "data-qa": "laboratories-list-content-lab-name",
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(item.lpu.name) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "text-body-2 text-secondary--text",
                          attrs: {
                            "data-qa": "laboratories-list-content-lab-address",
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(item.lpu.town.name) +
                              ", " +
                              _vm._s(item.lpu.address) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "ui-icon-arrow-right icon-secondary--text",
                    }),
                  ]
                )
              }),
              _vm._v(" "),
              _setup.hasLoadMoreLine
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          def: Intersect,
                          name: "intersect",
                          rawName: "v-intersect",
                          value: _setup.handleIntersect,
                          expression: "handleIntersect",
                        },
                      ],
                      staticClass:
                        "d-flex justify-center align-center px-1 py-4",
                      attrs: {
                        "data-qa": "laboratories-list-content-lab-more-text",
                      },
                    },
                    [
                      _c("div", { staticClass: "text-body-1" }, [
                        _vm._v("\n        Загружаем ещё...\n      "),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            2
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }